import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("td", {
  class: "time",
  rowspan: "2"
}, "時間", -1)
const _hoisted_2 = ["colspan"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { computed } from 'vue'
import { flatten } from 'lodash'
import { useInitDataStore } from '@/stores/initDataStore'
import { DefinitionInfoWeatherItemHeader } from '@/models/initData/DefinitionInfo'

type Props = {
  resolution: string
  style: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    resolution: null,
    style: null
  },
  setup(__props: any) {

const props = __props as {
  resolution: string
  style: string
}


const initDataStore = useInitDataStore()
const headers = computed(() => initDataStore.initData.definitionInfo.reports.weather[props.resolution].header)
const headerItems = computed(() => flatten(headers.value.map((h: DefinitionInfoWeatherItemHeader) => h.items)))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", {
    style: _normalizeStyle(__props.style),
    id: "tableHead",
    class: "table-head table-head-weather"
  }, [
    _createElementVNode("tr", null, [
      _hoisted_1,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headers), (header, index) => {
        return (_openBlock(), _createElementBlock("td", {
          colspan: header.items.length,
          key: index
        }, _toDisplayString(header.name), 9, _hoisted_2))
      }), 128))
    ]),
    _createElementVNode("tr", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerItems), (item, index) => {
        return (_openBlock(), _createElementBlock("td", { key: index }, [
          _createTextVNode(_toDisplayString(item.name), 1),
          (item.name && item.unit)
            ? (_openBlock(), _createElementBlock("br", _hoisted_3))
            : _createCommentVNode("", true),
          (item.unit)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(item.unit) + ")", 1))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ], 4))
}
}

})